import { downgradeComponent } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { AiAgentEditComponent } from 'src/app/parameters/alcmeon-ai/ai-agent-edit/ai-agent-edit.component';
import { AlcmeonAiComponent } from 'src/app/parameters/alcmeon-ai/alcmeon-ai/alcmeon-ai.component';
import { KnowledgeDocumentEditComponent } from 'src/app/parameters/alcmeon-ai/knowledge-document-edit/knowledge-document-edit.component.ts';

downgradedAngularModule.directive('angularAlcmeonAi', downgradeComponent({ component: AlcmeonAiComponent }));
downgradedAngularModule.directive('angularAiAgentEdit', downgradeComponent({ component: AiAgentEditComponent }));
downgradedAngularModule.directive(
  'angularKnowledgeDocumentEdit',
  downgradeComponent({ component: KnowledgeDocumentEditComponent })
);
